
<style scoped>
    button {
        min-width: initial;
        width: 100%;
        min-height: initial;
        height: 55px;
        border: unset;
        border-radius: unset;
        outline: unset;

        cursor: pointer;
        margin-top: 26px;
        margin-bottom: 26px;

        font-family: "Josefin Sans", system-ui, -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
            "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
            "Noto Color Emoji";
        font-size: 15px;
        font-weight: 700;
        text-transform: uppercase;
        background-color: rgb(37, 42, 43);
        color: rgb(255, 255, 248);
        transition: all 0.15s;
    }

    button:hover,
    button.Light:hover {
        border: unset;
        background-color: rgb(255, 109, 109);
        color: rgb(0, 0, 0);
    }

    button:focus,
    button:active {
        border: unset;
    }

    button.Light:not(:hover) {
        background-color: rgba(0, 0, 0, 0);
        color: rgb(37, 42, 43);
        border: 2px solid rgb(37, 42, 43);
    }
    button:disabled {
        cursor: not-allowed;
        background-color: rgba(37, 42, 43, 0.7);
        color: rgba(255, 255, 248, 0.7);
    }
    button.Light:disabled {
        background-color: rgba(0, 0, 0, 0);
        color: rgba(37, 42, 43, 0.5);
        border: 2px solid rgba(37, 42, 43, 0.5);
    }
</style>


<template lang="pug">

button( v-bind="$attrs" :class=[{ Light: light }] )
    slot



</template>


<script>

import { defineComponent, ref, reactive, } from 'vue'



export default defineComponent( {

    name: 'Button',

    props: ['light',],

    setup( props ) {



        return {

        }

    },

} )
</script>